import { httpRegex, LanguageLink } from "@hilma/netina2all";

export const formatQuestionAnswerWithLinks = (answer: string) =>
	answer
		.split('\n')
		.map(line =>
			<div>
				{line.split(/(\[.*?\]\s*\(.*?\))/g).map((section, index) => {
					const match = section.match(/\[(.*?)\]\s*\((.*?)\)/);
					if (match) {
						const customUrl = match[2].match(httpRegex);
						if (customUrl)
							return (
								<a key={index} href={match[2]} target='_blank' rel='noreferrer' className="dark-link">
									{` ${match[1]} `}
								</a>
							)
						return (
							<LanguageLink key={index} to={"/" + match[2]} className="dark-link">
								{` ${match[1]} `}
							</LanguageLink>
						)
					}
					return section;
				})}
			</div>)
